import { call, put } from 'redux-saga/effects';
import { types as onpremTypes } from '../reducers/onprem';
import * as Api from '../utils/Api';
import { Type as accountTypes } from '../reducers/Account';

export function* createDeployment(action) {
  const { organizationUUID } = action;
  if (!organizationUUID) {
    throw new Error('Missing required parameters for creating a deployment');
  }
  const response = yield call(
    Api.post,
    `organizations/${organizationUUID}/deployment`
  );
  if (!response.success) {
    yield put({
      type: onpremTypes.CREATE_DEPLOYMENT_FAILURE,
      error: response.data ? response.data.error_message : 'Unknown error',
      errorCode: response.status,
    });
    return;
  }
  yield put({ type: accountTypes.FETCH_ACCOUNT_REQUEST });
  yield put({
    type: onpremTypes.CREATE_DEPLOYMENT_SUCCESS,
    token: response.data.token,
    secret: response.data.secret,
  });
}

export function* deleteDeployment(action) {
  const { organizationUUID } = action;
  if (!organizationUUID) {
    throw new Error('Missing required parameters for deleting a deployment');
  }
  const response = yield call(
    Api.del,
    `organizations/${organizationUUID}/deployment`
  );
  if (!response.success) {
    yield put({
      type: onpremTypes.DELETE_DEPLOYMENT_FAILURE,
      error: response.data ? response.data.error_message : 'Unknown error',
      errorCode: response.status,
    });
    return;
  }
  yield put({ type: accountTypes.FETCH_ACCOUNT_REQUEST });
  yield put({
    type: onpremTypes.DELETE_DEPLOYMENT_SUCCESS,
  });
}

export function* testConnection(action) {
  const { organizationUUID } = action;
  if (!organizationUUID) {
    throw new Error('Missing required parameters for testing a connection');
  }
  const response = yield call(
    Api.post,
    `organizations/${organizationUUID}/deployment/test-connection`
  );
  if (!response.success) {
    yield put({
      type: onpremTypes.TEST_CONNECTION_FAILURE,
      error: response.data ? response.data.error_message : 'Unknown error',
      errorCode: response.status,
    });
  } else {
    yield put({
      type: onpremTypes.TEST_CONNECTION_SUCCESS,
    });
  }
  // update installed state on the organization in case this changed it
  yield put({ type: accountTypes.FETCH_ACCOUNT_REQUEST });
}

export function* manualUpgrade(action) {
  const { organizationUUID } = action;
  if (!organizationUUID) {
    throw new Error('Missing required parameters for setting manual upgrade');
  }
  const response = yield call(
    Api.post,
    `organizations/${organizationUUID}/deployment/manual-upgrade`
  );
  if (!response.success) {
    yield put({
      type: onpremTypes.MANUAL_UPGRADE_FAILURE,
      error: response.data ? response.data.error_message : 'Unknown error',
      errorCode: response.status,
    });
  } else {
    yield put({
      type: onpremTypes.MANUAL_UPGRADE_SUCCESS,
    });
  }
  // update updating state on the organization in case this changed it
  yield put({ type: accountTypes.FETCH_ACCOUNT_REQUEST });
}

export function* setAutoUpgrade(action) {
  const { organizationUUID, enable } = action;
  if (!organizationUUID || typeof enable !== 'boolean') {
    throw new Error('Missing required parameters for setting auto-upgrade');
  }
  const response = yield call(
    Api.post,
    `organizations/${organizationUUID}/deployment/set-auto-upgrade`,
    { enable }
  );
  if (!response.success) {
    yield put({
      type: onpremTypes.SET_AUTO_UPGRADE_FAILURE,
      error: response.data ? response.data.error_message : 'Unknown error',
      errorCode: response.status,
    });
  } else {
    yield put({
      type: onpremTypes.SET_AUTO_UPGRADE_SUCCESS,
    });
  }
  // update auto_upgrade_disabled state on the organization in case this changed it
  yield put({ type: accountTypes.FETCH_ACCOUNT_REQUEST });
}
